const Columns = [
  {
    field: 'StatementDateStart',
    headerName: '日期',
    cellRenderer(params) {
      return `${params.value.substr(
        0,
        10
      )}~${params.data.StatementDateEnd.substr(0, 10)}`;
    },
    width: 165
  },
  {
    field: 'BillNo',
    headerName: '对账单号',
    width: 125
  },
  {
    field: 'SupplierName',
    headerName: '供应商名称'
  },
  {
    field: 'Qty',
    headerName: '总数量',
    editable: false,
    width: 80
  },
  {
    field: 'Amount',
    headerName: '应收额',
    editable: false,
    width: 100,
    valueFormatter(params) {
      return params.value == null ? 0 : params.value;
    }
  },
  {
    field: 'RecPayAmount',
    headerName: '已收额',
    editable: false,
    width: 100,
    valueFormatter(params) {
      return params.value == null ? 0 : params.value;
    }
  },
  {
    field: 'TicketedAmount',
    headerName: '已开票额',
    editable: false,
    width: 100,
    valueFormatter(params) {
      return params.value == null ? 0 : params.value;
    }
  },
  {
    field: 'IncludeTax',
    headerName: '是否含税',
    editable: false,
    cellRenderer(params) {
      return params.value ? '含税' : '不含税';
    },
    width: 85
  },
  {
    field: 'IsAudited',
    headerName: '账单核对',
    cellRenderer(params) {
      return params.value ? '已核对' : '<span class="color-red">未核对</span>';
    },
    width: 85
  },
  {
    field: 'RecPayStatus',
    headerName: '收款状态',
    cellRenderer(params) {
      if (params.value == 1) {
        return '<span class="color-red">未收</span>';
      } else if (params.value == 2) {
        return '<span class="color-red">部分收</span>';
      } else {
        return '已全收';
      }
    },
    width: 85
  },
  {
    field: 'InvoicedStatus',
    headerName: '开票状态',
    cellRenderer(params) {
      if (params.value == 1) {
        return '<span class="color-red">未开</span>';
      } else if (params.value == 2) {
        return '<span class="color-red">部分开</span>';
      } else {
        return '已全开';
      }
    },
    width: 85
  },
  {
    field: 'BankReceipt',
    headerName: '银行水单',
    width: 85
  },
  {
    field: 'Operation',
    headerName: '操作',

    width: 120
  }
];
const StatementDetailsColumns = [
  {
    field: 'SourceBusinessDate',
    headerName: '日期',
    editable: false,
    valueFormatter(params) {
      return `${params.value.substr(0, 10)}`;
    },
    width: 90
  },
  {
    field: 'PONumber',
    headerName: '订单号',
    editable: false,
    width: 125
  },
  {
    field: 'ProductName',
    headerName: '开票品名'
    // editable: false
  },
  {
    field: 'Model',
    headerName: '型号',
    editable: false
  },
  {
    field: 'Qty',
    headerName: '数量',
    editable: false,
    width: 70
  },
  {
    field: 'TaxRate',
    headerName: '税率',
    editable: false,
    valueFormatter(params) {
      return params.value ? `${params.value}%` : '';
    },
    width: 55
  },
  // {
  //   field: 'CurrencyCode',
  //   headerName: '币种',
  //   editable: false,
  //   valueFormatter(params) {
  //     return params.value ? params.value : 'RMB';
  //   }
  // },
  {
    field: 'Price',
    headerName: '单价',
    editable: false,
    width: 90
  },
  {
    field: 'Amount',
    headerName: '金额',
    editable: false,
    width: 80
  },
  {
    field: 'RecPayAmount',
    headerName: '已收额',
    editable: false,
    width: 80,
    valueFormatter(params) {
      return params.value == null ? 0 : params.value;
    }
  },
  {
    field: 'TicketedAmount',
    headerName: '已开票额',
    editable: false,
    width: 80,
    valueFormatter(params) {
      return params.value == null ? 0 : params.value;
    }
  }
];
export { Columns, StatementDetailsColumns };
